import CustomerLike from './CustomerLike';

export default CustomerLike;
